var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showToolsBox,
          expression: "showToolsBox"
        },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      ref: "officeReEdit",
      staticClass: "officeReEdit",
      style: { pointerEvents: _vm.isPointer ? "none" : "auto" },
      attrs: { id: "officeReEdit" },
      on: {
        click: function($event) {
          return _vm.doPopoverClose()
        }
      }
    },
    [
      _vm.drawBackgroundImage
        ? _c("img", {
            staticStyle: {
              width: "100%",
              height: "100%",
              position: "absolute",
              left: "0",
              top: "0"
            },
            attrs: { src: _vm.drawBackgroundImage }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "popup-framework",
        {
          attrs: {
            "start-el": _vm.startEl,
            "end-el": _vm.endEl,
            visible: _vm.popupFrameworkShow,
            logo: _vm.currentEnv.css,
            title: _vm.currentEnv.systemType
          },
          on: {
            "update:visible": function($event) {
              _vm.popupFrameworkShow = $event
            },
            popupResize: _vm.popupResize
          },
          scopedSlots: _vm._u([
            {
              key: "menu",
              fn: function() {
                return [
                  _c(
                    "menu",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { title: "操作" }
                    },
                    [
                      _c(
                        "el-dropdown",
                        { attrs: { trigger: "hover" } },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { padding: "8px" }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: { icon: "el-icon-refresh-right" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.resetOs()
                                    }
                                  }
                                },
                                [_vm._v("重置数据")]
                              ),
                              _vm._v(" "),
                              _vm.currentEnv.platformType !==
                              _vm.envList.codeBlockOS.platformType
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: { icon: "el-icon-refresh" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.restartOs()
                                        }
                                      }
                                    },
                                    [_vm._v("重启环境\n            ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("it-env", {
            ref: "itEnv",
            attrs: {
              "platform-type": _vm.currentEnv.platformType,
              "iframe-src": _vm.iframeSrc
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "officeContent", attrs: { id: "officeContent" } },
        [
          _c(
            "div",
            {
              staticClass: "canvasBox",
              style: {
                width: _vm.isEdit ? _vm.canvasWidth + "px" : "1px",
                height: _vm.canvasHeight + "px",
                pointerEvents: _vm.isPointer ? "none" : "auto"
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.doPopoverClose()
                }
              }
            },
            [
              _c("canvas", {
                ref: "officeCanvas",
                attrs: {
                  id: "officeCanvas",
                  width: _vm.canvasWidth,
                  height: _vm.canvasHeight
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          style: { pointerEvents: "auto" },
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          !_vm.isGeneratePictures
            ? _c(
                "div",
                {
                  staticClass: "officeTools",
                  style: { "--translateY": _vm.isEdit ? "0%" : "100%" },
                  on: {
                    dblclick: function($event) {
                      return _vm.maximizeTools($event.target)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "drag",
                          rawName: "v-drag",
                          value: "left",
                          expression: "'left'"
                        }
                      ],
                      staticClass: "drag dragLeft"
                    },
                    [_vm._v("|||")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "drag",
                          rawName: "v-drag",
                          value: "right",
                          expression: "'right'"
                        }
                      ],
                      staticClass: "drag dragRight"
                    },
                    [_vm._v("|||")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "fold", on: { click: _vm.switchTools } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: (_vm.isEdit ? "收起" : "展开") + "(F2)",
                            placement: "top",
                            effect: "light"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-minus",
                            staticStyle: {
                              "font-size": "25px",
                              width: "100%",
                              height: "100%",
                              "text-align": "center"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "leftTools" },
                    _vm._l(_vm.leftTools, function(item) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !item.isHide,
                              expression: "!item.isHide"
                            }
                          ],
                          key: item.name,
                          on: {
                            click: function($event) {
                              return _vm.handleLeftTools(item)
                            }
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: item.label,
                                placement: "top",
                                effect: "light"
                              }
                            },
                            [_c("i", { class: item.type })]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "centerTools" },
                    [
                      _vm._l(_vm.centerTools.slice(0, 2), function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !item.isHide,
                                expression: "!item.isHide"
                              }
                            ],
                            key: item.name
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  slot: "reference",
                                  content: item.label,
                                  placement: "top",
                                  effect: "light"
                                },
                                slot: "reference"
                              },
                              [
                                _c("i", {
                                  class: item.type,
                                  style: {
                                    color: _vm.getDisableIsNext(index)
                                      ? "#ccc"
                                      : null,
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCenterTools(item, index)
                                    }
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.centerTools.slice(2, 3), function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !item.isHide,
                                expression: "!item.isHide"
                              }
                            ],
                            key: item.name
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  slot: "reference",
                                  content: item.label,
                                  placement: "top",
                                  effect: "light"
                                },
                                slot: "reference"
                              },
                              [
                                _c("i", {
                                  class: item.type,
                                  style: _vm.getToolsStyle(item),
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCenterTools(item, index)
                                    }
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.centerTools.slice(3), function(item, index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !item.isHide,
                                expression: "!item.isHide"
                              }
                            ],
                            key: item.name
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                ref: "mPopover",
                                refInFor: true,
                                attrs: {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "click",
                                  openDelay: 200
                                }
                              },
                              [
                                item.name === "pencil"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "grid",
                                          "grid-template-columns":
                                            "repeat(2,auto)",
                                          "justify-items": "center",
                                          cursor: "pointer"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("el-color-picker", {
                                              attrs: {
                                                predefine: _vm.predefineColors
                                              },
                                              on: {
                                                "active-change": function(
                                                  color
                                                ) {
                                                  return _vm.pickerChange(
                                                    color,
                                                    "currentColor"
                                                  )
                                                },
                                                change: function(color) {
                                                  return _vm.pickersChange(
                                                    _vm.predefineColors,
                                                    _vm.currentColor,
                                                    color
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.currentColor,
                                                callback: function($$v) {
                                                  _vm.currentColor = $$v
                                                },
                                                expression: "currentColor"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("el-slider", {
                                              staticStyle: {
                                                "margin-left": "15px",
                                                width: "100px"
                                              },
                                              attrs: { min: 1, max: 100 },
                                              on: { change: _vm.sliderChange },
                                              model: {
                                                value: _vm.currentWidth,
                                                callback: function($$v) {
                                                  _vm.currentWidth = $$v
                                                },
                                                expression: "currentWidth"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : item.name === "eraser"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "grid",
                                          "grid-template-columns":
                                            "repeat(2,auto)",
                                          "justify-items": "center",
                                          "align-items": "center",
                                          cursor: "pointer"
                                        }
                                      },
                                      [
                                        _vm._l(item.children, function(it) {
                                          return _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !it.isHide,
                                                  expression: "!it.isHide"
                                                }
                                              ],
                                              key: it.name,
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleCenterTools(
                                                    it
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content: it.label,
                                                    placement: "top",
                                                    effect: "light"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    class: it.type,
                                                    staticStyle: {
                                                      "font-size": "24px"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleCenterTools(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("el-slider", {
                                              staticStyle: {
                                                "margin-left": "15px",
                                                width: "100px"
                                              },
                                              attrs: { min: 1, max: 100 },
                                              on: { change: _vm.sliderChange },
                                              model: {
                                                value: _vm.currentEraserWidth,
                                                callback: function($$v) {
                                                  _vm.currentEraserWidth = $$v
                                                },
                                                expression: "currentEraserWidth"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  : item.name === "more"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "grid",
                                          "row-gap": "10px",
                                          "grid-template-columns":
                                            "repeat(3,auto)",
                                          "justify-items": "center",
                                          cursor: "pointer"
                                        }
                                      },
                                      [
                                        _vm._l(item.children, function(
                                          it,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !it.isHide,
                                                  expression: "!it.isHide"
                                                }
                                              ],
                                              key: it.name,
                                              staticStyle: {
                                                width: "60px",
                                                "text-align": "center"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleCenterTools(
                                                    it
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content: it.label,
                                                    placement:
                                                      index < 3
                                                        ? "top"
                                                        : "bottom",
                                                    effect: "light"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    class: it.type,
                                                    staticStyle: {
                                                      "font-size": "24px",
                                                      padding: "5px",
                                                      margin: "2px"
                                                    },
                                                    style: _vm.getToolsStyle(it)
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "inherit",
                                              display: "flex",
                                              "grid-column": "1/5",
                                              "border-radius": "5px",
                                              border: "1px solid #cccccc",
                                              padding: "4px",
                                              "box-sizing": "border-box"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c("el-color-picker", {
                                                  attrs: {
                                                    predefine:
                                                      _vm.predefineShapeColors
                                                  },
                                                  on: {
                                                    "active-change": function(
                                                      color
                                                    ) {
                                                      return _vm.pickerChange(
                                                        color,
                                                        "currentShapeColor"
                                                      )
                                                    },
                                                    change: function(color) {
                                                      return _vm.pickersChange(
                                                        _vm.predefineShapeColors,
                                                        _vm.currentShapeColor,
                                                        color
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.currentShapeColor,
                                                    callback: function($$v) {
                                                      _vm.currentShapeColor = $$v
                                                    },
                                                    expression:
                                                      "currentShapeColor"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("el-slider", {
                                                  staticStyle: {
                                                    "margin-left": "15px",
                                                    width: "110px",
                                                    "margin-right": "15px"
                                                  },
                                                  attrs: { min: 1, max: 50 },
                                                  on: {
                                                    change: _vm.sliderChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.currentShapeWidth,
                                                    callback: function($$v) {
                                                      _vm.currentShapeWidth = $$v
                                                    },
                                                    expression:
                                                      "currentShapeWidth"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      content: item.label,
                                      placement: "top",
                                      effect: "light"
                                    },
                                    slot: "reference"
                                  },
                                  [
                                    _c("i", {
                                      class: item.type,
                                      style: _vm.getToolsStyle(item),
                                      on: {
                                        click: function($event) {
                                          return _vm.handleCenterTools(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rightTools" },
                    [
                      _vm._l(_vm.rightTools.slice(0, 1), function(item) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !item.isHide,
                                expression: "!item.isHide"
                              }
                            ],
                            key: item.name,
                            on: {
                              click: function($event) {
                                return _vm.handleRightTools(item, $event)
                              }
                            }
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                ref: "mPopover",
                                refInFor: true,
                                attrs: {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "click",
                                  openDelay: 200
                                }
                              },
                              [
                                item.name === "os" &&
                                item.children &&
                                item.children.length
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "grid",
                                          "justify-items": "center",
                                          cursor: "pointer"
                                        },
                                        style: {
                                          "grid-template-columns":
                                            "repeat(" +
                                            item.children.length +
                                            ",1fr)"
                                        }
                                      },
                                      _vm._l(item.children, function(it) {
                                        return _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !it.isHide,
                                                expression: "!it.isHide"
                                              }
                                            ],
                                            staticStyle: {
                                              width: "50px",
                                              "text-align": "center"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.openOS(it)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content: it.systemType,
                                                  placement: "top",
                                                  effect: "light"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  class: it.css,
                                                  staticStyle: {
                                                    "font-size": "24px"
                                                  },
                                                  style: {
                                                    color:
                                                      _vm.currentEnv
                                                        .systemType ===
                                                      it.systemType
                                                        ? "#21a7fd"
                                                        : null
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.isHide,
                                        expression: "!item.isHide"
                                      }
                                    ],
                                    attrs: {
                                      slot: "reference",
                                      content: item.label,
                                      placement: "top",
                                      effect: "light"
                                    },
                                    slot: "reference"
                                  },
                                  [_c("i", { class: item.type })]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.rightTools.slice(1, 2), function(item) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !item.isHide,
                                expression: "!item.isHide"
                              }
                            ],
                            key: item.name,
                            on: {
                              click: function($event) {
                                return _vm.handleRightTools(item, $event)
                              }
                            }
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                ref: "mPopover",
                                refInFor: true,
                                attrs: {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "click",
                                  openDelay: 200
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "max-height": "300px",
                                      "overflow-y": "auto",
                                      padding: "5px"
                                    }
                                  },
                                  [
                                    _vm._l(_vm.noteList, function(note) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass: "officeReEditLoadBook",
                                          style: {
                                            border:
                                              _vm.currentNodeId === note.id
                                                ? "1px solid #21a7fd"
                                                : null
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectNote(note)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-image",
                                            {
                                              key: note.id,
                                              attrs: {
                                                src: note.notesUrl,
                                                fit: "fill",
                                                lazy: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "error" },
                                                  slot: "error"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-picture-outline"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    _vm._v(" "),
                                    !_vm.noteList || !_vm.noteList.length
                                      ? _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "text-align": "center"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                暂无\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.isHide,
                                        expression: "!item.isHide"
                                      }
                                    ],
                                    attrs: {
                                      slot: "reference",
                                      content: item.label,
                                      placement: "top",
                                      effect: "light"
                                    },
                                    slot: "reference"
                                  },
                                  [_c("i", { class: item.type })]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.rightTools.slice(2), function(item) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !item.isHide,
                                expression: "!item.isHide"
                              }
                            ],
                            key: item.name,
                            on: {
                              click: function($event) {
                                return _vm.handleRightTools(item, $event)
                              }
                            }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  slot: "reference",
                                  content: item.label,
                                  placement: "top",
                                  effect: "light"
                                },
                                slot: "reference"
                              },
                              [_c("i", { class: item.type })]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7da0dfed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da0dfed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/teachingDetail/list/classroom/officeReEdit.vue
// module id = null
// module chunks = 